import {signInTypes} from "../../actions/AuthActions/AuthActionsTypes/SignInActionsTypes";

const initSignInState = {
    loading: false,
    success: false,
    verified: false,
};

/**
 *
 * @param state
 * @param action
 * @returns {object}
 * @constructor
 */
const SignInReducer = (state = initSignInState, action) => {
    switch (action.type) {
        case signInTypes.SIGN_IN_REQUEST: {
            return Object.assign({}, state, {
                loading: true,
                success: false,
            });
        }

        case signInTypes.SIGN_IN_SUCCESS: {
            return Object.assign({}, state, {
                loading: false,
                success: true,
            });
        }

        case signInTypes.SIGN_IN_FAILURE: {
            return Object.assign({}, state, {
                loading: false,
                success: false,
            });
        }

        default: {
            return state;
        }
    }
};

export default SignInReducer;
